import Entity from './entity'

export default class ShopeeBaseSettingList extends Entity<number>{
    tenancyName: string;
    createTime: Date;
    authorizeTime?: Date;
    shopNumberLimit?: number;
    authorizeCategory: number;
    subAccountsCount?: number;
    amount?: number;
    channelName: string;
    remark: string;
    channelId: number;
}